import { useMemo, ReactNode } from "react";
import { useSelector } from "react-redux";
import UserlensProvider from "userlens-analytics-sdk/react";

import { selectUser } from "src/store/user/userSelector";
import { selectCompanyById } from "src/store/company/companySelector";
import { selectCompanySubscriptionPlan } from "src/store/subscriptionPlans/subscriptionPlansSelector";

type UserlensWrapperProps = {
  children: ReactNode;
};

const { REACT_APP_USERLENS_WRITE_CODE = "" } = process.env;

export const UserlensWrapper = ({ children }: UserlensWrapperProps) => {
  const user = useSelector(selectUser);
  const company = useSelector((state: Store.RootState) =>
    selectCompanyById(state, user.companyId),
  );
  const companySubscriptionPlan = useSelector(selectCompanySubscriptionPlan);

  const config = useMemo(() => {
    if (
      !user.id ||
      !company ||
      !companySubscriptionPlan ||
      !REACT_APP_USERLENS_WRITE_CODE
    ) {
      return null;
    }

    return {
      WRITE_CODE: REACT_APP_USERLENS_WRITE_CODE,
      userId: user.id,
      userTraits: {
        email: user.email,
        name: `${user.firstName} ${user.lastName}`.trim() || "",
        firstName: user.firstName || "",
        lastName: user.lastName || "",
        companyRole: user.companyRole || "",
        createdAt: user.createdAt || "",
      },
      groupId: user.companyId,
      groupTraits: {
        name: company.name || "",
        countryCode: company.countryCode || "",
        subscriptionPlan: companySubscriptionPlan?.name || "",
      },
    };
  }, [user, company, companySubscriptionPlan]);

  if (!config) {
    return <>{children}</>;
  }

  return <UserlensProvider config={config}>{children}</UserlensProvider>;
};
